module.exports = __webpack_public_path__ + "static/media/profile-bg.d2b14d4b.png";